var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-mt-bubble mt-2"},[_c('div',{staticClass:"flex-row-1 align-center"},[_c('div',{staticClass:"flex-row-1"},[_c('img',{staticClass:"sc-phone-item",attrs:{"alt":"Category","src":_vm.getImage()}}),_c('div',{staticClass:"sc-phone-container"},[_c('span',{staticClass:"sc-phone-subtitle"},[_vm._v(_vm._s(_vm.sub))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }